import React from 'react';
import {connect} from 'react-redux';
import _ from 'lodash'

import Header from './_Header'
import Item from './_Item'
import AddNewItem from './_AddNewItem'
import LockItem from './_LockItem'

import {Flex, Hint, Spinner} from '/app/src/component';

import Jibber from '/app/src/jibber'
import {ExchangeModel, CustomizationModel} from '/app/src/model'


class ExchangeSystem extends Jibber{
    constructor(props){
        super(props);
        this.useState({
            options: props.options
        })
        this.draftItem = this.draftItem.bind(this)
        this.saveItems = this.saveItems.bind(this)
    }

    componentDidMount(){
        this.props.readRequest()
    }

    componentDidUpdate(prevProps, prevState){
        if(prevProps.options !== this.props.options){
            this.setOptions(this.props.options)
            this.setChanged(false)
        }
    }
    // draft changes here, only save when the save button is pressed
    draftItem(id, label, visible, sub_id){
        var {options} = this.state
        var index = _.findIndex(options, ['id', id])
        if(sub_id){
            var sub_index = _.findIndex(options[index].children, ['id', sub_id])
            options[index]['children'][sub_index].label = label
            options[index]['children'][sub_index].visible = visible
            this.setOptions(options)
            return;
        }
        options[index].visible = visible
        options[index].label = label
        this.setOptions(options)
    }

    // Save the items to backend
    saveItems(){
        var {options} = this.state

        if(this.state.changed){
            let anyOptionVisible = ExchangeModel.selector.isAnyVisible(options)
            this.props.updatesRequest(this.state.options)
            if(!anyOptionVisible)
                this.props.updateLiveExchange(false)
            this.setChanged(false)
        }
    }

    render() {
        const {networkReadRequest, live} = this.props
        const {options, changed} = this.state

        let anyOptionVisible = ExchangeModel.selector.isAnyVisible(options)

        if(!networkReadRequest.fetched || networkReadRequest.fetching){
            return <Flex w='100%' h='100%' center><Spinner/></Flex>
        }
        return(
            <Flex w='100%' column hAlignContent='center'>
                <Header onSave={this.saveItems} live={live} changed={changed}

                    onLiveChange={(e)=>{
                        // must be from props here
                        this.props.updateLiveExchange(e.target.value)}
                    }
                    liveDisable={!ExchangeModel.selector.isAnyVisible(this.props.options) && !this.props.live}
                    liveReason={'Inga ämnen aktiva'}
                />
            <Flex w='100%' paddingTop='50px' column hAlignContent='center' overflowY='scroll' paddingBottom='100px'>
                    <Flex w='70%' fontSize='18px' lineHeight='24px' color='black' shrink={0}>
                    Växelsystemet ger besökarna möjlighet att välja vilket typ av ämne deras ärende gäller. Medarbetare kan sedan välja vilka av dessa ämnen/kanaler de vill ha ärenden ifrån, så att ni kan sätta rätt person på rätt område.
                    </Flex>
                    <Flex fontSize='24px' fontWeight='300' marginTop='80px' marginBottom='100px'>
                    Ämnen/Kanaler <Hint tooltip='Lägg till kategorier och underkategorier
som passar just er verksamhet.'/>
                    </Flex>
                    <Flex column shink={0} marginBottom='400px'>
                        {_.map(options, (item)=>{
                            return <Item
                                key={item.id}
                                item={item}
                                onDelete={this.props.deleteRequest}
                                onUpdate={this.draftItem}
                                onCreateSubItem={this.props.createRequest}
                            />
                        })}
                        {options.length !== 0 &&
                            <LockItem label='Övriga frågor' height='41px'
                                fontSize='24px'
                                parentVisible={anyOptionVisible}
                                />
                        }
                        <AddNewItem onClick={(text)=>{this.props.createRequest(text, false)}}/>
                    </Flex>
                </Flex>
            </Flex>
        );
    }
}

const  {selector: readSelector, dispatcher: readRequest} = ExchangeModel.read()
const  {dispatcher: createRequest} = ExchangeModel.create()
const  {dispatcher: deleteRequest} = ExchangeModel.delete()
const  {dispatcher: updatesRequest} = ExchangeModel.updates()

const  {selector: updatesCustSelector, dispatcher: updatesCustRequest} = CustomizationModel.updates()

const mapDispatchToProps = (dispatch, props) =>({
    readRequest: ()=> dispatch(readRequest()),
    createRequest: (label, parent_id)=>{
        if(!label) return;
        dispatch(createRequest({label, parent_id}))
    },
    deleteRequest: (option_id)=>dispatch(deleteRequest(option_id)),
    updatesRequest: (options)=>dispatch(updatesRequest(options)),
    updateLiveExchange: (on)=>dispatch(updatesCustRequest({exchange_on: on}))
})

const mapStateToProps = (state, props) => ({
    networkReadRequest: readSelector.network(state),
    options: readSelector.options(state),
    live: updatesCustSelector.customization(state).exchange_on,
})

export default connect(mapStateToProps, mapDispatchToProps)(ExchangeSystem)



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/Exchange/index.js